import React, { useState, useEffect } from 'react';
import './Home.css'
import girlImage from './images/girl.png'
import Im from './images/discussion.png'; // Import the image file
import Y from './images/vcall.png'
import W from './images/girl-with-books.png'
import Q from './images/true-false.png'
import R from './images/gradebook.png'
import S from "./images/discussion.png"
import T from './images/integrations.png'
import U from './images/testimonials.png'
import M from './images/laptop-news.png'
import N from './images/children-laptop.png'
import O from './images/girl-laptop.png'
import P from './images/cat-laptop.png'
import L from './images/lider.png'
import ImpluzImage from '../images/Impluz.png'; // Adjust the path
import { Tabs, Tab } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import RequestStudentForm from './RequestStudent';
import { Modal } from 'react-bootstrap';
import axios from '../Axiosinstance'
import { Link } from 'react-router-dom';
import Loader from '../Loader';

const MainSection = () => {
  const [showModal, setShowModal] = useState(false);

  // Function to open the modal
  const openModal = () => {
    setShowModal(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div class="hero bg-cream"  >
      <div class="main">
        <div class="hero-content">
          <h2><span>Welcome to iMPULZ</span> Learning Management System.</h2>
          <p>Impulz is an interesting software application or web-based technology for learning programs or materials for learning and
            development programs administration,
            documentation, tracking, reporting, automation, and delivery of educational courses</p>
          <div class="buttons">
            <a href='/'><button>Sign In</button></a>
            <button onClick={openModal}>Sign Up</button>
          </div>
        </div>
        {/* <div class="img">
          <img src={girlImage} alt="Girl" />
        </div> */}
      </div>
      <Modal show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Request Student Form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RequestStudentForm closeModal={closeModal} />
        </Modal.Body>

      </Modal>
    </div>
  );
};






export const Categories = () => {
  const [categoryData, setCategoryData] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('categorys');
        setCategoryData(response.data);
        setLoading(false); // Set loading to false when data is received
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false); // Set loading to false in case of an error
      }
    };

    fetchData();
  }, []);

  return (
    <div id='heading'>
      <div className="heading" >
        <h4>
          <span>Categories</span>
        </h4>
      </div>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="pro">


              {categoryData.map((category, index) => (
                <div key={index} className="procontainer">
                  <div className="image-container">
                    {category.url ? (
                      <img
                        src={category.url}
                        alt={category.name}
                        style={{
                          width: '400px',
                          height: '200px',
                        }}
                      />
                    ) : (
                      <div className="default-image"></div>
                    )}
                    <div className='head'>
                      <h2 style={{ marginTop: '-6%' }} className="proheading">{category.name}</h2>
                    </div>
                    <Link
                      className="read-more"
                      to={`/Categories/${category.id}`}
                      style={{
                        textDecoration: 'none',
                        display: 'inline-block',
                        padding: '8px 16px',
                        backgroundColor: '#007bff',
                        color: '#fff',
                        borderRadius: '4px',
                        transition: 'background-color 0.3s ease',
                        marginTop: '5%',

                      }}
                    >
                      Read more
                    </Link>


                  </div>
                </div>
              ))}


            </div>

          </>
        )}
      </div>
    </div>
  );
};





const Face = () => {
  return (
    <div class="feature mt-4" >
      <div class="heading"  >
        <h4>All-In-One <span>Cloud Software</span></h4>
      </div>
      <div class="feature-card">
        <div class="card">
          <svg viewBox="0 0 33 46" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-white"><path d="M24.75 23H8.25V28.75H24.75V23ZM32.3984 9.43359L23.9852 0.628906C23.5984 0.224609 23.0742 0 22.5242 0H22V11.5H33V10.952C33 10.3859 32.7852 9.83789 32.3984 9.43359ZM19.25 12.2188V0H2.0625C0.919531 0 0 0.961328 0 2.15625V43.8438C0 45.0387 0.919531 46 2.0625 46H30.9375C32.0805 46 33 45.0387 33 43.8438V14.375H21.3125C20.1781 14.375 19.25 13.4047 19.25 12.2188ZM5.5 6.46875C5.5 6.07164 5.80766 5.75 6.1875 5.75H13.0625C13.4423 5.75 13.75 6.07164 13.75 6.46875V7.90625C13.75 8.30336 13.4423 8.625 13.0625 8.625H6.1875C5.80766 8.625 5.5 8.30336 5.5 7.90625V6.46875ZM5.5 12.2188C5.5 11.8216 5.80766 11.5 6.1875 11.5H13.0625C13.4423 11.5 13.75 11.8216 13.75 12.2188V13.6562C13.75 14.0534 13.4423 14.375 13.0625 14.375H6.1875C5.80766 14.375 5.5 14.0534 5.5 13.6562V12.2188ZM27.5 39.5312C27.5 39.9284 27.1923 40.25 26.8125 40.25H19.9375C19.5577 40.25 19.25 39.9284 19.25 39.5312V38.0938C19.25 37.6966 19.5577 37.375 19.9375 37.375H26.8125C27.1923 37.375 27.5 37.6966 27.5 38.0938V39.5312ZM27.5 21.5625V30.1875C27.5 30.9817 26.8847 31.625 26.125 31.625H6.875C6.11531 31.625 5.5 30.9817 5.5 30.1875V21.5625C5.5 20.7683 6.11531 20.125 6.875 20.125H26.125C26.8847 20.125 27.5 20.7683 27.5 21.5625Z" fill="white"></path></svg>
          <h4>Virtual Learning Environment (VLE)</h4>
          <p>A VLE is an online platform for education, set up by educational institutions or available for public access, providing access to educational content via computers or mobile devices.
          </p>
        </div>
        <div class="card">
          <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-white"><path d="M12 0C11.0532 0 10.2857 0.767511 10.2857 1.71432V5.14285H13.7142V1.71432C13.7142 0.767511 12.9467 0 12 0Z" fill="white"></path><path d="M36 0C35.0532 0 34.2856 0.767511 34.2856 1.71432V5.14285H37.7142V1.71432C37.7143 0.767511 36.9468 0 36 0Z" fill="white"></path><path d="M42.8571 5.14282H37.7143V12C37.7143 12.9468 36.9468 13.7143 36 13.7143C35.0532 13.7143 34.2857 12.9468 34.2857 12V5.14282H13.7142V12C13.7142 12.9468 12.9467 13.7143 11.9999 13.7143C11.0531 13.7143 10.2856 12.9468 10.2856 12V5.14282H5.14285C2.30253 5.14282 0 7.44535 0 10.2857V42.8571C0 45.6974 2.30253 48 5.14285 48H42.8571C45.6975 48 48 45.6974 48 42.8571V10.2857C48 7.44535 45.6975 5.14282 42.8571 5.14282ZM44.5714 42.8571C44.5714 43.8039 43.8039 44.5714 42.857 44.5714H5.14285C4.19605 44.5714 3.42854 43.8039 3.42854 42.8571V20.5714H44.5714V42.8571Z" fill="white"></path><path d="M13.7142 23.9999H10.2857C9.33889 23.9999 8.57138 24.7674 8.57138 25.7142C8.57138 26.661 9.33889 27.4285 10.2857 27.4285H13.7142C14.661 27.4285 15.4285 26.661 15.4285 25.7142C15.4285 24.7674 14.661 23.9999 13.7142 23.9999Z" fill="white"></path><path d="M25.7143 23.9999H22.2857C21.3389 23.9999 20.5714 24.7674 20.5714 25.7142C20.5714 26.661 21.3389 27.4285 22.2857 27.4285H25.7143C26.6611 27.4285 27.4286 26.661 27.4286 25.7142C27.4286 24.7674 26.6611 23.9999 25.7143 23.9999Z" fill="white"></path><path d="M37.7143 23.9999H34.2857C33.3389 23.9999 32.5714 24.7674 32.5714 25.7142C32.5714 26.661 33.3389 27.4285 34.2857 27.4285H37.7143C38.6611 27.4285 39.4286 26.661 39.4286 25.7142C39.4286 24.7674 38.661 23.9999 37.7143 23.9999Z" fill="white"></path><path d="M13.7142 30.8571H10.2857C9.33889 30.8571 8.57138 31.6246 8.57138 32.5714C8.57138 33.5182 9.33889 34.2857 10.2857 34.2857H13.7142C14.661 34.2857 15.4285 33.5182 15.4285 32.5714C15.4285 31.6246 14.661 30.8571 13.7142 30.8571Z" fill="white"></path><path d="M25.7143 30.8571H22.2857C21.3389 30.8571 20.5714 31.6246 20.5714 32.5714C20.5714 33.5182 21.3389 34.2857 22.2857 34.2857H25.7143C26.6611 34.2857 27.4286 33.5182 27.4286 32.5714C27.4286 31.6246 26.6611 30.8571 25.7143 30.8571Z" fill="white"></path><path d="M37.7143 30.8571H34.2857C33.3389 30.8571 32.5714 31.6246 32.5714 32.5714C32.5714 33.5182 33.3389 34.2857 34.2857 34.2857H37.7143C38.6611 34.2857 39.4286 33.5182 39.4286 32.5714C39.4285 31.6246 38.661 30.8571 37.7143 30.8571Z" fill="white"></path><path d="M13.7142 37.7142H10.2857C9.33889 37.7142 8.57138 38.4817 8.57138 39.4286C8.57138 40.3754 9.33889 41.1428 10.2857 41.1428H13.7142C14.661 41.1428 15.4285 40.3753 15.4285 39.4284C15.4285 38.4816 14.661 37.7142 13.7142 37.7142Z" fill="white"></path><path d="M25.7143 37.7142H22.2857C21.3389 37.7142 20.5714 38.4817 20.5714 39.4285C20.5714 40.3754 21.3389 41.1429 22.2857 41.1429H25.7143C26.6611 41.1429 27.4286 40.3754 27.4286 39.4285C27.4286 38.4817 26.6611 37.7142 25.7143 37.7142Z" fill="white"></path><path d="M37.7143 37.7142H34.2857C33.3389 37.7142 32.5714 38.4817 32.5714 39.4285C32.5714 40.3754 33.3389 41.1429 34.2857 41.1429H37.7143C38.6611 41.1429 39.4286 40.3754 39.4286 39.4285C39.4286 38.4817 38.661 37.7142 37.7143 37.7142Z" fill="white"></path></svg>
          <h4>Hassle-free Agenda Planning</h4>
          <p>Create/join meetings , high-quality audio/video, end-to-end encryption, and screen sharing. Emphasises convenience, simplicity, and security.</p>
        </div>
        <div class="card">
          <svg viewBox="0 0 55 44" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-white"><path d="M8.25 19.25C11.2836 19.25 13.75 16.7836 13.75 13.75C13.75 10.7164 11.2836 8.25 8.25 8.25C5.21641 8.25 2.75 10.7164 2.75 13.75C2.75 16.7836 5.21641 19.25 8.25 19.25ZM46.75 19.25C49.7836 19.25 52.25 16.7836 52.25 13.75C52.25 10.7164 49.7836 8.25 46.75 8.25C43.7164 8.25 41.25 10.7164 41.25 13.75C41.25 16.7836 43.7164 19.25 46.75 19.25ZM49.5 22H44C42.4875 22 41.1211 22.6102 40.1242 23.5984C43.5875 25.4977 46.0453 28.9266 46.5781 33H52.25C53.7711 33 55 31.7711 55 30.25V27.5C55 24.4664 52.5336 22 49.5 22ZM27.5 22C32.8195 22 37.125 17.6945 37.125 12.375C37.125 7.05547 32.8195 2.75 27.5 2.75C22.1805 2.75 17.875 7.05547 17.875 12.375C17.875 17.6945 22.1805 22 27.5 22ZM34.1 24.75H33.3867C31.5992 25.6094 29.6141 26.125 27.5 26.125C25.3859 26.125 23.4094 25.6094 21.6133 24.75H20.9C15.4344 24.75 11 29.1844 11 34.65V37.125C11 39.4023 12.8477 41.25 15.125 41.25H39.875C42.1523 41.25 44 39.4023 44 37.125V34.65C44 29.1844 39.5656 24.75 34.1 24.75ZM14.8758 23.5984C13.8789 22.6102 12.5125 22 11 22H5.5C2.46641 22 0 24.4664 0 27.5V30.25C0 31.7711 1.22891 33 2.75 33H8.41328C8.95469 28.9266 11.4125 25.4977 14.8758 23.5984Z" fill="white"></path></svg>
          <h4>Milestone tracking</h4>
          <p>Integrated with the functionality to automate and track emails to individuals or groups. </p>
        </div>
      </div>
    </div>
  );
};

















const What = () => {
  return (
    <div>

      <div class="intro mt-5">
        <div class="heading">
          <h4 style={{ color: "White" }}>What is <span>Impluz?</span></h4>
          <p style={{ color: '#fff' }}>Impluz is a platform that allows educators to create online classes whereby they can store the course materials online, manage assignments, quizzes, and exams, and monitor due dates.
            grade results and provide students with feedback all in one place.
            Typically, Impulse learning management system provides an instructor with a way to create and deliver content, monitor student participation, and assess student performance. It might also provide students with interactive features, such as threaded discussions, video conferencing and discussion forums.</p>
        </div>
        <div id="Demo" class="container">
          <div class="instructor platform">
            <h4>FOR INSTRUCTORS</h4>
            <button>Start a class today</button>
          </div>
          <div class="student platform">
            <h4>FOR STUDENT</h4>
            <button>Enter Access code</button>
          </div>
        </div>
      </div>





      <div class="everything mt-6" id='Feature'>
        <div class="main">
          <div class="content">
            <div class="orange-circle"></div>
            <h4>Replicate physical classroom experiences virtually <span>you can do with Impluz</span></h4>
            <p>Impluz's school management software helps traditional and online schools manage scheduling, attendance,
              payments and virtual classrooms all in one secure cloud-based system.</p>
            <a href="">Learn More</a>
          </div>
          <div className="img">
            <div className="blue"></div>
            <div className="orange"></div>
            <img src={Im} alt="i" />
            <div className="play">
              <i className="bi bi-play-fill"></i>
            </div>
          </div>
        </div>
      </div>





      <div class="user-interface">
        <div class="main">
          <div className="img">
            <img src={Y} className="vcall" alt="" /> {/* Use the imported image */}
            <div className="green"></div>
            <div className="blue"></div>
          </div>
          <div class="content">
            <h4>A <span> user interface</span> designed for the classroom</h4>
            <ul class="list">
              <li>
                {/* <svg viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4"><rect width="11.8182" height="11.8182" rx="2" fill="#2F327D"></rect><rect y="14.1816" width="11.8182" height="11.8182" rx="2" fill="#2F327D"></rect><rect x="14.7727" width="11.8182" height="11.8182" rx="2" fill="#2F327D"></rect><rect x="14.7727" y="14.1816" width="11.8182" height="11.8182" rx="2" fill="#F48C06"></rect></svg> */}
                <p>Enhanced teacher visibility, dedicated podium space, prioritized TA and presenter placement, and comprehensive class data.</p>
              </li>



            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

const Port = () => {
  return (
    <div>
      <div class="tool mt-5">
        <div class="main">
          <div class="content">
            <h4><span>Tools</span> For Teachers And Learners</h4>
            <p>Class has a dynamic set of teaching tools built to be deployed and used during class. Teachers can handout
              assignments in real-time for students to complete and submit.</p>
          </div>
          <div class="img">
            <img src={W} alt="" />
          </div>
        </div>
      </div>





      <div class="test mt-6">
        <div class="main">
          <div class="img">
            <img src={Q} alt="" />
          </div>
          <div class="content">
            <h4>Assessments, <span>Quizzes</span>, Tests</h4>
            <p>Easily launch live assignments, quizzes, and tests. Student results are automatically entered in the online gradebook.</p>
          </div>
        </div>
      </div>








      <div class="management mt-5">
        <div class="main">
          <div class="content">
            <h4><span>Class Management</span> Tools for Educators</h4>
            <p>Class provides tools to help run and manage the class such as Class Roster, Attendance, and more. With the Gradebook, teachers can review and grade tests and quizzes in real-time.</p>
          </div>
          <div class="img">
            <img src={R} alt="" />
          </div>
        </div>
      </div>








      <div class="discussion mt-5">
        <div class="main">
          <div class="img">
            <img src={S} alt="" />
          </div>
          <div class="content">
            <h4>One-on-One<span> Discussions</span></h4>
            <p>Teachers and teacher assistants can talk with students privately without leaving the Zoom environment.</p>
          </div>
        </div>
      </div>
      <div class="btn mt-2">

      </div>





      <div class="integration mt-6">
        <div class="main">
          <div class="img">
            <img src={T} alt="" />
          </div>
          <div class="content">
            <small><div class="line"></div> INTEGRATION</small>
            <h4>200+ educational tools and platform<span>integrations</span></h4>
            <p>Schoology has every tool your classroom needs and comes pre-integrated with more than 200+ tools, student information systems (SIS), and education platforms.</p>

          </div>
        </div>
      </div>





      <div class="testimonial mt-6" id='ssg'>
        <div class="main">
          <div class="content">
            <small><div class="line"></div> SkillsFuture Singapore and Workforce Singapore</small>
            <h4>SSG - WSQ</h4>
            <p>SkillsFuture Singapore and Workforce Singapore for improved user experience and easier access to relevant information."</p>
            {/* <p>Some of the students and teachers were greatly helped by the Impluz.</p>
                <p>Are you too? Please give your assessment</p> */}
            <a href='https://www.skillsfuture.gov.sg/'>click here</a>
          </div>
          <div class="img">
            <img src={U} alt="" />
          </div>
        </div>
      </div>




    </div>

  );
};













const Page = () => {
  return (




    <div>
      <div class="blog mt-5" id='Blogs'>
        <div class="heading">
          <h4>Latest News and Resources</h4>
          <p style={{ color: '#fff' }}>See the developments that have occurred to Impluz in the world</p>
        </div>
        <div class="blog-container">
          <div class="main-blog">
            <div class="blog-img">
              <img src={M} alt="" />
            </div>
            <div class="blog-content">
              <h4>Class adds $30 million to its balance sheet for a Zoom-friendly edtech solution</h4>
              <p>Class, launched less than a year ago by Blackboard co-founder Michael Chasen, integrates exclusively...</p>
              <a href="">Read More</a>
            </div>
          </div>
          <div class="blog-post">
            <div class="post">
              <div class="img">
                <img src={N} alt="" />
              </div>
              <div class="blog-content">
                <h4>Class Technologies Inc. Closes $30 Million Series A Financing to Meet High Demand</h4>
                <p>Class Technologies Inc., the company that created Class,...</p>
              </div>
            </div>
            <div class="post">
              <div class="img">
                <img src={O} alt="" />
              </div>
              <div class="blog-content">
                <h4>Zoom’s earliest investors are betting millions on a better Zoom for schools</h4>
                <p>Zoom was never created to be a consumer product. Nonetheless, the...</p>
              </div>
            </div>
            <div class="post">
              <div class="img">
                <img src={P} alt="" />
              </div>
              <div class="blog-content">
                <h4>Former Blackboard CEO Raises $16M to Bring LMS Features to Zoom Classrooms</h4>
                <p>This year, investors have reaped big financial returns from betting on Zoom...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};














const individual = () => {
  return (
    <div>

      <MainSection />
      <Categories />
      <Face />
      <What />
      <Port />
      <Page />
    </div>
  );
};

export default individual
